export default __webpack_public_path__ + "static/A07-241708f1a440aa1d4998d52f0439bf98.jpg";